import { render, staticRenderFns } from "./HisMovimiento.vue?vue&type=template&id=af67e0c0&scoped=true"
import script from "./HisMovimiento.vue?vue&type=script&lang=js"
export * from "./HisMovimiento.vue?vue&type=script&lang=js"
import style0 from "./HisMovimiento.vue?vue&type=style&index=0&id=af67e0c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af67e0c0",
  null
  
)

export default component.exports